/**
 * AI Product Mapping — structured rail-event builders.
 *
 * Events are plain objects rendered as text segments by RailEvent —
 * deliberately NO HTML strings (user-controlled values like file names and
 * CSV headers flow into event messages), so there is no innerHTML surface.
 *
 * Event shape: { id, ts, level, kind?, segments: [{ text, variant }], data? }
 */

import type { RailEvent, RailSegment } from './types';

/** Local "HH:MM:SS" timestamp for rail-log lines (to the second — sub-second precision
 *  adds noise without value in the real stream). */
export function pmTs(d: Date = new Date()): string {
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${h}:${m}:${s}`;
}

export const seg = {
  plain: (text: string): RailSegment => ({ text, variant: 'plain' }),
  mono: (text: string): RailSegment => ({ text, variant: 'mono' }),
  num: (text: string): RailSegment => ({ text, variant: 'num' }),
  strongNum: (text: string): RailSegment => ({ text, variant: 'strong-num' }),
};

let eventSeq = 0;

export function createRailEvent(
  level: RailEvent['level'],
  segments: RailSegment[],
  extra: Partial<Pick<RailEvent, 'kind' | 'data'>> = {},
): RailEvent {
  eventSeq += 1;
  return {
    id: `e${eventSeq}_${Date.now()}`,
    ts: pmTs(),
    level,
    segments,
    ...extra,
  };
}
